import { render, staticRenderFns } from "./ThePopup.vue?vue&type=template&id=48b33ca4&"
import script from "./ThePopup.vue?vue&type=script&lang=ts&"
export * from "./ThePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports